import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Variable List
export const fetchVariableList = createAsyncThunk(
  "variableList/fetchVariableList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/panel/PanelVariableMap");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update Variable List
export const updateVariableList = createAsyncThunk(
  "variableList/updateVariableList",
  async (variableData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/panel/PanelVariableMap", variableData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Add Variable List
export const addVariableList = createAsyncThunk(
  "variableList/addVariableList",
  async (newVariableData, { rejectWithValue }) => {
    try {
      const response = await api.post("/panel/PanelVariableMap", newVariableData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

const variableListSlice = createSlice({
  name: "variable",
  initialState: {
    variableList: null,
    status: "idle",
    error: null,
    selectedVariableId: Number(localStorage.getItem("selectedVariableId")) || null,
  },
  reducers: {
  setSelectedVariableId: (state, action) => {
    state.selectedVariableId = action.payload;

    localStorage.setItem(
      "selectedVariableId",
      action.payload
    );
  },
  clearSelectedVariableId: (state) => {
  state.selectedVariableId = null;
  localStorage.removeItem("selectedVariableId");
},
},

  extraReducers: (builder) => {
    builder
      .addCase(fetchVariableList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVariableList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.variableList = action.payload;
      })
      .addCase(fetchVariableList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateVariableList.pending, (state) => {
        // state.status = "loading";
        state.error = null;
      })
      .addCase(updateVariableList.fulfilled, (state, action) => {
        // state.status = "succeeded";
        state.variableList = { ...state.variableList, ...action.payload };
      })
      .addCase(updateVariableList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(addVariableList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addVariableList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.variableList = [...(state.variableList || []), action.payload];
      })
      .addCase(addVariableList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export const { setSelectedVariableId , clearSelectedVariableId} = variableListSlice.actions;
export default variableListSlice.reducer;
